/**
 * Atrasados: abertos da fila com entrega já vencida. Ficam sempre à vista
 * (em qualquer aba e escala) porque entram primeiro na fila e são o que o
 * PCP precisa reprogramar.
 */
import React, { useState } from "react";

import { plural } from "../../utils/dinheiro";
import { ddmm } from "./apresentacao";
import { useAbrirCenario } from "./contextoReprogramar";
import ItemAmbiente from "./ItemAmbiente";
import { BotaoTexto, Bloco, ListaRecuada, ListaSimples, Ponto, Regua } from "./styles";

export default function BlocoAtrasados({ itens, expandirTudo, podeAbrir, onAbrir }) {
  const [aberto, setAberto] = useState(false);
  const abrirCenario = useAbrirCenario();
  if (!itens.length) return null;
  const mostrar = expandirTudo || aberto;
  return (
    <Bloco data-pdf="capacidade-atrasados">
      <h2>
        <Ponto $tom="danger" aria-hidden="true" />
        Atrasados <span>{itens.length}</span>
      </h2>
      <Regua>
        {plural(itens.length, "ambiente da fila está", "ambientes da fila estão")} com a entrega vencida. Eles entram
        primeiro na fila, antes dos que ainda estão no prazo.
      </Regua>
      {mostrar ? (
        <ListaRecuada>
          <ListaSimples>
            {itens.map((item, i) => (
              <ItemAmbiente
                key={item.identidade || `${item.chave}-${i}`}
                item={item}
                meta={`venceu ${ddmm(item.entrega)}`}
                mostrarCamada
                podeAbrir={podeAbrir}
                onAbrir={onAbrir}
              />
            ))}
          </ListaSimples>
        </ListaRecuada>
      ) : null}
      {!expandirTudo ? (
        <BotaoTexto type="button" aria-expanded={aberto} onClick={() => setAberto((v) => !v)}>
          {aberto ? "Esconder a lista" : "Ver a lista de atrasados"}
        </BotaoTexto>
      ) : null}
      {abrirCenario && !expandirTudo ? (
        // O primeiro atrasado da planilha já vem escolhido; o seletor do
        // cenário lista os outros no topo. Venda assinada não tem pedido.
        <BotaoTexto type="button" onClick={() => abrirCenario(itens.find((item) => item.pedido) || null)}>
          Reprogramar um atrasado no Cenário do PCP
        </BotaoTexto>
      ) : null}
    </Bloco>
  );
}
